
const transformCubePointsToVertices = (cubePoints) => {
    // Define vertices for each face explicitly
    // Order: front, back, top, bottom, right, left
    // Each face is defined by four vertices, hence 6 faces * 4 vertices = 24 vertices
    const faceVertices = [
        // Front face
        cubePoints[3],
        cubePoints[2],
        cubePoints[6],
        cubePoints[7],
        // Back face
        cubePoints[4],
        cubePoints[5],
        cubePoints[1],
        cubePoints[0],
        // Top face
        cubePoints[4],
        cubePoints[7],
        cubePoints[6],
        cubePoints[5],
        // Bottom face
        cubePoints[0],
        cubePoints[1],
        cubePoints[2],
        cubePoints[3],
        // Right face
        cubePoints[1],
        cubePoints[5],
        cubePoints[6],
        cubePoints[2],
        // Left face
        cubePoints[4],
        cubePoints[0],
        cubePoints[3],
        cubePoints[7],
    ];

    // Flatten the array of vertices since the graphics library expects a flat array
    const vertices = faceVertices.flat();

    // Optionally, convert to a Float32Array if needed for WebGL/Three.js
    // This step is necessary if the API expects a typed array for performance reasons
    const verticesArray = new Float32Array(vertices.flat());

    return verticesArray;
};

export default transformCubePointsToVertices
